import React from "react";
import Link from "helpers/link";
import { ReactComponent as Plus } from "assets/svgs/plus.svg";
import { useGlobalContext } from "context/global";
import { useSelector } from "react-redux";

const NoSubscription = () => {
	const { translation } = useGlobalContext();
	const { emailAddress: { emailAddress } } = useSelector(state => state.account.profile);
	return (
		<div className="no-subscription-container">
			<div className="w-full">
				<h2 className="mb-2 break-words">{translation.subscription?.no_subs?.replace("{email}", emailAddress)}</h2>
				<span>{translation?.subscription?.check_promos}</span>
				<Link to="/box">
					<div className="flex justify-center my-4">
						<Plus /> <span className="ml-2">{translation?.subscription?.order_now}</span>
					</div>
				</Link>
			</div>
		</div>
	);
};

export default NoSubscription;